import { Box, Typography } from '@mui/material';
import DownloadPDFModal from '../../../../components/DownloadPDFModal/DownloadPDFModal';
import { GenericTable } from '@components';
import PdfHeader from '../../../../components/DownloadPDFModal/PdfHeader';
import { Game } from '../FundingEligibility/types';

const disclaimerItems = [
  '1. The figures presented in this report are based solely on data shared by the Company and are only as accurate as the information provided.',
  '2. Data is validated on a monthly basis between the Company and PvX Capital to ensure alignment.',
  '3. This report reflects the cash flow position and repayment tracking from the perspective of PvX Capital. The Company may have different accounting treatments or internal classifications for these transactions.',
];

interface DownloadReportsPdfProps {
  isOpen: boolean;
  handleClose: () => void;
  selectedGame: Game | undefined;
  getBalanceChartData: () => any;
  getPrincipalChartData: () => any;
}

const DownloadReportsPdf: React.FC<DownloadReportsPdfProps> = ({
  isOpen,
  handleClose,
  selectedGame,
  getBalanceChartData,
  getPrincipalChartData,
}) => {
  return (
    <DownloadPDFModal
      isOpen={isOpen}
      handleClose={handleClose}
      fileName={`Download_Reports_${selectedGame?.name}.pdf`}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: 'auto',
          }}
        >
          <PdfHeader />
        </Box>
        <Box
          sx={{
            padding: '1.25rem',
            backgroundColor: '#FFFFFF',
            borderRadius: '0.75rem',
            marginBottom: '1.125rem',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1.375rem',
              color: '#1B1C17',
            }}
          >
            Reports
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1.5rem',
              color: '#6C6C6C',
            }}
          >
            {selectedGame?.name}
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            padding: '0.875rem',
            backgroundColor: '#FFF',
            borderRadius: '0.75rem',
            marginBottom: '0.75rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.25rem',
              justifyContent: 'space-between',
              marginBottom: '1rem',
            }}
          >
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 700,
                color: '#162936',
                lineHeight: '1.375rem',
              }}
            >
              Principal & Interest Payment
            </Typography>
          </Box>
          <GenericTable
            data={getPrincipalChartData()?.rows || []}
            columns={getPrincipalChartData()?.columns || []}
            meta={getPrincipalChartData()?.metadata || []}
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            padding: '0.875rem',
            backgroundColor: '#FFF',
            borderRadius: '0.75rem',
            marginBottom: '0.75rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.25rem',
              justifyContent: 'space-between',
              marginBottom: '1rem',
            }}
          >
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 700,
                color: '#162936',
                lineHeight: '1.375rem',
              }}
            >
              Outstanding Balance
            </Typography>
          </Box>
          <GenericTable
            data={getBalanceChartData()?.rows || []}
            columns={getBalanceChartData()?.columns || []}
            meta={getBalanceChartData()?.metadata || []}
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            padding: '0.875rem',
            backgroundColor: '#FFF',
            borderRadius: '0.75rem',
            marginBottom: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 700,
              color: '#162936',
              lineHeight: '1.375rem',
              marginBottom: '1rem',
            }}
          >
            Disclaimer
          </Typography>

          {disclaimerItems.map((item, index) => (
            <Typography
              key={index}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: '#6C6C6C',
                lineHeight: '1.25rem',
                marginBottom: '0.25rem',
              }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    </DownloadPDFModal>
  );
};

export default DownloadReportsPdf;
